import React, { useState } from "react";
import { useFetchDocumentDetails } from "../../API/Queries/useFetchDocumentDetails";
import { useUpdateUserName } from "../../API/Queries/useUpdateUserName";
import { useUpdateUserMobile } from "../../API/Queries/useUpdateUserMobile";
import Loader from "../../Components/Loader";
import GeneralToast from "../../Components/Toaster";
import "./index.css";

const UserProfile = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [newName, setNewName] = useState("");
  const [newMobile, setNewMobile] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [mobileErrorMessage, setMobileErrorMessage] = useState("");
  const [nameErrorMessage, setNameErrorMessage] = useState("");

  const {
    data: userData,
    error: fetchError,
    isLoading: contactFetchLoading,
    mutate: dataFetch,
  } = useFetchDocumentDetails();

  const updateNameMutation = useUpdateUserName();
  const updateMobileMutation = useUpdateUserMobile();

  const handleSearchQueryChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;
    setSearchQuery(value);
  };

  const handleSearch = () => {
    if (!searchQuery.trim() || !/^\d{10}$/.test(searchQuery)) {
      setErrorMessage("Please enter a valid 10-digit mobile number.");
      return;
    }
    setErrorMessage("");
    dataFetch({ input: { contactNumber: searchQuery } });
    setNewName("");
    setNewMobile("");
    setMobileErrorMessage("");
    setNameErrorMessage("");
  };

  const handleNewNameChange = (e) => {
    const value = e.target.value;
    setNewName(value);

    if (userData?.data?.name === value) {
      setNameErrorMessage("Data with new name already exists");
    } else {
      setNameErrorMessage("");
    }
  };

  const handleNewMobileChange = (e) => {
    const value = e.target.value;
    setNewMobile(value);
    if (userData?.data?.primaryPhoneNumber === value) {
      setMobileErrorMessage("Data with new phone number already exists");
    } else {
      setMobileErrorMessage("");
    }
  };

  const handleUpdateName = () => {
    if (
      !userData?.data ||
      newName === userData?.data?.name
    )
      return;

    updateNameMutation.mutate(
      {
        uuid: userData?.data?.id,
        userRealmDetail: { name: newName },
      },
      {
        onSuccess: () => {
          userData.data.name = newName;
          setNewName("");
        },
        onError: (error) => {
          setErrorMessage(error.message || "Failed to update user name!");
        },
      }
    );
  };

  const handleUpdateMobile = () => {
    if (!userData?.data || !/^\d{10}$/.test(newMobile)) return;

    if (newMobile === userData?.data?.primaryPhoneNumber) {
      setMobileErrorMessage("Data with new phone number already exists");
      return;
    }

    updateMobileMutation.mutate(
      {
        input: {
          existingContactNumber: userData?.data?.primaryPhoneNumber,
          newContactNumber: newMobile,
        },
      },
      {
        onSuccess: (res) => {
          if (res?.status === 200) {
            setNewMobile("");
            setMobileErrorMessage("");
            dataFetch({ input: { contactNumber: newMobile } });
          } else {
            setMobileErrorMessage(
              res?.errorMessage || "Unexpected error occurred"
            );
          }
        },
        onError: (error) => {
          setMobileErrorMessage(
            error?.response?.data?.errorMessage ||
              "Failed to update user mobile!"
          );
        },
      }
    );
  };

  return (
    <>
      {(contactFetchLoading ||
        updateNameMutation.isLoading ||
        updateMobileMutation.isLoading) && <Loader />}
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
      {(fetchError ||
        (userData?.data && Object.keys(userData.data).length === 0)) && (
        <GeneralToast type="error" message="User not found!" />
      )}

      <div className="container-user">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by Mobile Number"
            value={searchQuery}
            onChange={handleSearchQueryChange}
            maxLength="10"
          />
          <button onClick={handleSearch} disabled={!searchQuery.trim()}>
            Search
          </button>
        </div>
        {userData?.data && Object.keys(userData.data).length > 0 && (
          <div className="user-details">
            <div className="basic-details">
              <h2>Basic User Details</h2>
              <div className="detail-row">
                <label>User ID:</label>
                <span>{userData?.data?.systemUserId || "Null"}</span>
              </div>
              <div className="detail-row">
                <label>Name:</label>
                <span>{userData?.data?.name || "Null"}</span>
              </div>
              <div className="detail-row">
                <label>Mobile No.:</label>
                <span>{userData?.data?.primaryPhoneNumber || "Null"}</span>
              </div>
            </div>

            <div className="edit-details">
              <h2>Editable User Details</h2>
              <label>New Name</label>
              <input
                type="text"
                value={newName}
                onChange={handleNewNameChange}
              />
              {nameErrorMessage && (
                <p className="error-message">{nameErrorMessage}</p>
              )}
              <button
                className={
                  newName?.length > 0 &&
                  newName !== userData?.data?.name
                    ? "enabled"
                    : ""
                }
                onClick={handleUpdateName}
                disabled={
                  newName?.length === 0 ||
                  newName === userData?.data?.name ||
                  updateNameMutation.isLoading
                }
              >
                Save Changes
              </button>

              <label>New Mobile No.</label>
              <input
                type="text"
                value={newMobile}
                onChange={handleNewMobileChange}
                maxLength="10"
              />
              {mobileErrorMessage && (
                <p className="error-message">{mobileErrorMessage}</p>
              )}
              <button
                className={
                  /^\d{10}$/.test(newMobile) &&
                  newMobile !== userData?.data?.primaryPhoneNumber
                    ? "enabled"
                    : ""
                }
                onClick={handleUpdateMobile}
                disabled={
                  !/^\d{10}$/.test(newMobile) ||
                  newMobile === userData?.data?.primaryPhoneNumber ||
                  updateMobileMutation.isLoading
                }
              >
                Save Changes
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserProfile;
